import {MetaTitleDesc} from "./meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Спорт';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Брестская областная физкультурно-спортивная организация занимается развитием 34 видов спорта. В
                        области работает 56 детско-юношеских спортивных школ, в том числе 23 специализированных
                        детско-юношеских школы олимпийского резерва.</p>
                    <p>В области работает Брестское областное училище олимпийского резерва. </p>
                    <p>В Брестской областной школе высшего спортивного мастерства работают отделения по 7 видам
                        спорта.</p>
                    <p>Важнейшими задачами в деятельности областной физкультурной организации являются подготовка
                        спортсменов высокого класса и спортивного резерва, привлечение населения к систематическим
                        занятиям физической культурой и спортом.</p>
                    <p>Для достижения поставленных целей в области имеется: дворец спорта, гребной канал, 4 гребные
                        базы, 4 легкоатлетических манежа, 36 стадионов, 153 футбольных поля, 2 поля для хоккея на траве,
                        1237 площадок для спортивных игр, 3 конно-спортивных базы, 668 стандартных и 696 нестандартных
                        спортивных зала, более 100 плавательных бассейнов, около 250 тиров для стрельбы, стрельбище для
                        стендовой стрельбы, 3 лыжные базы, 15 теннисных кортов из них - 4 крытых.</p>
                    <p>16 спортивных сооружений области включены в перечень спортивных сооружений, являющихся основными
                        базами подготовки национальных и сборных команд Республики Беларусь. </p>
                    <p>Брестская область одна из наиболее активно строящихся областей в республике. В текущем
                        Олимпийском цикле завершено строительство таких крупных спортивных сооружений, как
                        легкоатлетический манеж, стрелковый тир, зал тяжелой атлетики, игровой спортивный зал
                        «Виктория», и других.</p>
                </div>
            </div>
        </>
    );
}